<template>
  <div class="horizontal layout center">
    <div
      class="count-answer"
      v-if="!$store.state.isScreenCapture"
      v-tooltip="tooltipCountUserOnline"
      :class="{
        'has-reaction':
          $store.state.slideActive.type != 'openEnded' &&
          $store.state.slideActive.type != 'multipleChoice' &&
          $store.state.slideActive.type != 'wordCloud' &&
          $store.state.slideActive.type != 'qrcode' &&
          $store.state.slideActive.type != 'pickAnswer' &&
          $store.state.slideActive.type != 'leaderboard',
      }"
    >
      <i
        class="fas fa-user fa-fw"
        aria-hidden="true"
        :class="{ 'animate__bounceIn animate__animated': userCountAnimation }"
      />
      <span
        class="user-online-status"
        :class="{
          online: $store.state.userOnline > 0,
          'status-border': $store.state.slideActive.textColour == '#313131',
          warning: $store.state.onlineStatus == 2,
          danger: $store.state.onlineStatus == 3,
        }"
      />
      <span class="ml-0.5">{{ ($store.state.userOnline || 0) | formatTotalPoint }}
        <span
          class="show-limit-online"
          v-if="
            $store.state.plan &&
              $store.state.plan.group != 'white-label' &&
              $store.state.plan.group != 'pro' &&
              !$store.state.sharePresentation"
        >
          <span class="limit-slash">/</span><span class="limit-number" />{{
            $store.state.plan.limit
          }}
        </span>
      </span>
    </div>
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import EventBus from '@/eventBus'

export default {
  data() {
    return {
      userCountAnimation: false,
    }
  },

  computed: {
    tooltipCountUserOnline() {
      const { userOnline } = this.$store.state
      if (userOnline <= 0 || !userOnline) {
        return '0 live participant right now'
      } if (userOnline === 1) {
        return '1 live participant right now'
      }
      return `${userOnline} live participants right now`
    },

  },

  mounted() {
    const self = this
    EventBus.$on('userOnlineCount', () => {
      if (!self.userCountAnimation) {
        self.userCountAnimation = true
        setTimeout(() => {
          self.userCountAnimation = false
        }, 2000)
      }
    })
  },
}
</script>
